import firebase from '@firebase/app';
import '@firebase/auth';
import { router } from '@/router';
import { store } from '@/store';
import dotenv from 'dotenv';
dotenv.config();

const config = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
};

export class FirebaseModule {
  public init() {
    firebase.initializeApp(config);
    firebase.auth!().setPersistence(firebase.auth!.Auth.Persistence.LOCAL);
  }

  public signIn(username: string, password: string) {
    firebase.auth!()
      .signInWithEmailAndPassword(username, password)
      .then((user: any) => {
        router.push('/');
      })
      .catch(error => {
        alert(error.message);
      });
  }

  public signInTwitter() {
    const provider = new firebase.auth!.TwitterAuthProvider();
    firebase.auth!()
      .signInWithPopup(provider)
      .then(result => {
        router.push('/');
      })
      .catch(error => {
        alert(error.message);
      });
  }

  public signUp(username: string, password: string) {
    firebase.auth!()
      .createUserWithEmailAndPassword(username, password)
      .then(user => {
        alert(`Create account: ${user}`);
      })
      .catch(error => {
        alert(error.message);
      });
  }

  public logout() {
    firebase.auth!().signOut();
    router.push('/signin');
  }

  public onAuth() {
    return new Promise((resolve, reject) => {
      firebase.auth!().onAuthStateChanged(user => {
        if (user) {
          user = user || user;
          store.dispatch('User/updateUser', user);
          store.dispatch('User/updateStatus', user.uid || true);
          resolve();
        } else {
          router.push('/signin');
          resolve();
        }
      });
    });
  }
}
